"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = require("@microsoft/load-themed-styles");
load_themed_styles_1.loadStyles([{ "rawString": ".lean-rooster{padding:4px}.lean-rooster img{max-width:100%;-ms-flex-item-align:center;align-self:center}.lean-rooster.show-placeholder::before{color:rgba(0,0,0,0.55);content:attr(data-placeholder);cursor:text;font-style:italic;pointer-events:none}\n" }]);
//# sourceMappingURL=LeanRooster.scss.g.js.map